import request from '@/config/axios'

export interface CompanyInfo {
  id?: number
  memberId?: number
  regionId?: number
  companyName?: string
  licenseNo?: string
  licenseImgUrl?: string
  legalPerson?: string
  legalPersonNum?: string
  companyType?: string
  contactName?: string
  contactMobile?: string
  industryId?: number
  address?: string
  accountNo?: string
  authStatus?: boolean
  authFlowStatus?: number
  authFlowRejectReason?: string
  authFlowSubmitAt?: string
  authFlowAuditAt?: string
  dynamicFormData?: { id: number; value: string }[]
}

export const getCompanyList = () =>
  request.get<CompanyInfo[]>({ url: '/txn/company/list' })

export const getCompanyDetail = (id: number) =>
  request.get<CompanyInfo>({ url: '/txn/company/get', params: { id } })

export const saveCompany = (data: CompanyInfo) =>
  request.post({ url: '/txn/company/edit', data })

export const submitCompanyCert = (id: number) =>
  request.post({ url: '/txn/company/submitCompanyCert', data: { id } })

export const licenseOcr = (imageUrl: string) =>
  request.get({ url: '/infra/ocr/recognizeBizLicense', params: { imageUrl } })
